import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getBanksPaginated = ({ churchId, page, pageSize }) => {
  return axios.get(
    `/churches/${churchId}/banks-paginated?page=${page}&per_page=${pageSize}`
  );
};

export const useBanksPaginated = ({
  churchId,
  config,
  page,
  pageSize
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["banks-paginated", churchId, page, pageSize],
    queryFn: () => getBanksPaginated({ churchId, page, pageSize })
  });
};
